import { useSyncExternalStore } from 'react';
import { isJobId, isRecord, isVersion } from './generationValidation';
import { DeletionRequest } from './versionTypes';
const STORAGE_KEY = 'admin.map-deletion.request';
const STORAGE_ERROR = '!unavailable';
const listeners = new Set<() => void>();
let submitting = false;
function snapshot(): string | null {
  try { return sessionStorage.getItem(STORAGE_KEY); } catch { return STORAGE_ERROR; }
}
function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  window.addEventListener('storage', listener);
  return () => { listeners.delete(listener); window.removeEventListener('storage', listener); };
}
function notify(): void { listeners.forEach((listener) => listener()); }
export function parseDeletionRequest(raw: string | null): DeletionRequest | null {
  if (raw === null) return null;
  const request: unknown = JSON.parse(raw);
  if (!isRecord(request) || !isVersion(request.version) || typeof request.key !== 'string' || !/^[A-Za-z0-9._:-]{1,128}$/.test(request.key) || (request.id !== undefined && !isJobId(request.id))) throw new Error('Не удалось восстановить запрос удаления. Требуется оператор.');
  return { version: request.version, key: request.key, ...(request.id === undefined ? {} : { id: request.id }) };
}
export function useDeletionRequest(): { request: DeletionRequest | null; storageFailed: boolean } {
  const raw = useSyncExternalStore(subscribe, snapshot);
  try { return { request: parseDeletionRequest(raw), storageFailed: false }; } catch { return { request: null, storageFailed: true }; }
}
export function saveDeletionRequest(request: DeletionRequest): void {
  const serialized = JSON.stringify(request);
  sessionStorage.setItem(STORAGE_KEY, serialized);
  notify();
}
export function acquireDeletionSubmit(): boolean {
  if (submitting) return false;
  submitting = true;
  return true;
}
export function releaseDeletionSubmit(): void { submitting = false; }
export function createDeletionRequest(version: string): DeletionRequest {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  const parts = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return { version, key: `delete-${parts.join('')}` };
}
